<!-- <div class="innerBanner" style="background-image: url('{{ privacyDetails.bannerImage }}')"> -->
<!-- <img
      [src]="privacyDetails.bannerImage ? privacyDetails.bannerImage : '../../../assets/images/NoImage.jpg'"
      style="width: 100%"
    /> -->
<!-- <div class="bannerText"></div>
</div> -->

<div
  class="innerBanner"
  [style.background-image]="'url(' + privacyDetails.bannerImage + ')'"
  (click)="imageClick(0)"
></div>

<p-galleria
  [(value)]="images"
  [(visible)]="displayCustom"
  [(activeIndex)]="activeIndex"
  [fullScreen]="true"
  [showItemNavigators]="false"
  [baseZIndex]="100000"
  [containerStyle]="{ 'max-width': '90%' }"
>
  <ng-template pTemplate="item" let-item>
    <img [src]="item" class="gallery-image" />
  </ng-template>
</p-galleria>

<!-- <nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a href="/home">Home</a></li>
    <li class="breadcrumb-item active" aria-current="page">{{ privacyDetails.bannerTitle }}</li>
  </ol>
</nav> -->

<div class="container contentPanel">
  <!-- <app-breadcrumb></app-breadcrumb> -->
  <!-- <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a href="/home">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">{{ privacyDetails.bannerTitle }}</li>
    </ol>
  </nav> -->
  <app-breadcrumb-row></app-breadcrumb-row>
  <!-- <h1>{{ privacyDetails.bannerTitle }}</h1> -->
  <div class="pageTitle">
    <div class="privacyPolicy" #privacyPolicy style="background-color: #00a7a6">
      <div class="row p-3">
        <div class="col-md-12 col-sm-12">
          <h4 class="slider-text big-title title text-uppercase text-center text-white">{{ city }}</h4>
          <h4 class="slider-text big-title title text-uppercase text-center text-white">
            {{ todaydate | date: 'MMM dd, yyyy' }}
          </h4>
        </div>
      </div>
      <div class="row p-3 align-center">
        <div class="col-6">
          <figure>
            <img src="/assets/images/ic_thermometer.svg" alt="thermometer" class="left w16" />
            <div class="text-white pl20">
              <h2>{{ temp }}&#8451;</h2>
            </div>
          </figure>
        </div>
        <div class="col-6">
          <figure>
            <img [src]="weatherimg" alt="Trulli" />
            <figcaption class="text-white">
              <h2>{{ weather }}</h2>
            </figcaption>
          </figure>
        </div>
      </div>

      <div class="row p-3">
        <div class="col-md-12 text-white">Daily:</div>
      </div>

      <div class="row p-3">
        <div class="col" *ngFor="let hoursdata of hours">
          <figure>
            <img [src]="hoursdata.icon" alt="clouds" />
            <!-- <figcaption class="text-white">{{ hoursdata.temp }}&#8451;</figcaption>  -->
            <figcaption class="text-white text-lowercase">{{ hoursdata.dt_txt | date: 'ha' }}</figcaption>
          </figure>
        </div>
      </div>
      <br />
    </div>
  </div>
  <br />
  <br />
</div>
